// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__3-UvP","rootSmall":"AddTileButton_rootSmall__2FCFi"};